<template>
  <div>
    <v-checkbox
      v-if="!isContent"
      class="ml-2"
      :label="getLabel('all_workspaces')"
      :input-value="workspaces.includes('*')"
      :error="workspaces.length === 0 && errors.length > 0"
      @change="permissionAllWorkspaces"
    />
    <v-autocomplete
      ref="workspacesSelect"
      v-model="workspaces"
      :items="workspacesToShow"
      item-text="name"
      item-value="code"
      :label="getLabel('workspaces')"
      multiple
      chips
      clearable
      :disabled="workspaces.includes('*')"
      :error="workspaces.length === 0 && errors.length > 0"
      @change="includeAllWorkspaces"
    />
    <v-btn v-if="showBack" outlined @click="previousStep">
      <v-icon class="mr-2">mdi-arrow-left</v-icon>
      {{ getLabel("back") }}
    </v-btn>
    <v-btn class="ml-2" color="success" outlined @click="nextStep">
      {{ getLabel("continue") }}
      <v-icon class="ml-2">mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

import { useMainStore } from '../../store/index';
import { getLabel } from '@/utils/index';

export default {
  props: {
    restriction: {
      type: Object,
      required: true
    },
    showBack: {
      type: Boolean,
      default: true,
      required: false
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },
  setup (props, { emit, refs }) {
    const store = useMainStore();

    const errors = ref([]);

    const isContent = computed(() => props.restriction.type === 'hide_contents' || props.restriction.type === 'show_only_contents');

    const workspaces = ref(props.restriction.workspaces || []);

    const workspacesToShow = computed(() => store.workspaces.filter(w => w.project === props.restriction.project));

    const permissionAllWorkspaces = active => {
      if (active) {
        workspaces.value = ['*'];
      } else {
        workspaces.value = [];
      }
    };

    const includeAllWorkspaces = value => {
      if (isContent.value) {
        workspaces.value = value[1] ? [value[1]] : [value[0]];
      }

      if (workspaces.value.length === workspacesToShow.value.length) {
        workspaces.value = ['*'];

        // close the select window when all workspaces are selected
        refs.workspacesSelect.blur();
      }
    };

    const previousStep = () => {
      let restriction = null;
      if (!props.editMode) {
        restriction = { ...props.restriction };
        workspaces.value = [];
        restriction.workspaces = [];
      }

      emit('previousStep', restriction);
    };

    const nextStep = () => {
      if (workspaces.value.length === 0) {
        errors.value = [getLabel('insert_minimum_workspace')];
        emit('showErrors', errors.value);
        return;
      }
      errors.value = [];

      if (props.editMode !== true) {
        emit('updateRestriction', { ...props.restriction, workspaces: workspaces.value, settings: {} });
      } else {
        emit('updateRestriction', { ...props.restriction, workspaces: workspaces.value });
      }
    };

    return {
      getLabel,
      errors,
      isContent,
      workspaces,
      workspacesToShow,
      permissionAllWorkspaces,
      includeAllWorkspaces,
      previousStep,
      nextStep
    };
  }

};
</script>
